


export const downloadMulti = (urls:string[],options:{delay?:number} = {})=>{
  const { delay = 800 } = options
  // const repeatCount = 20;
  const downloadFileWithAnchor = (filename:string) => {
    const anchor = document.createElement("a");
    // anchor.href = "data:text/plain;charset=utf-8,";
    anchor.href = filename;
    // anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };
  if(Array.isArray(urls)){
    for (let i = 0; i < urls.length; i += 1) {
      setTimeout(
        () => {
          downloadFileWithAnchor(urls[i]);
        },
        i * delay // Delay download every 200ms
      );
    }
    // urls.forEach(downloadFileWithAnchor)
  }else{
    downloadFileWithAnchor(urls)
  }
}